document.addEventListener('Searchanise.Loaded', function () {
    (function ($) {

        /* =========================
                   SETTINGS
           =========================

           HOW THIS WORKS:
           1) pageRuleMapping ("pageRuleMapping") variable decides WHICH pages use a rule
           2) autoFilterRules ("autoFilterRules") variable  decides WHICH filters that rule applies

           You should be able to control the functionality fully via editing these 2 variables here. The variables and instructions for editing them are below.
        */

        /* 
           AUTO FILTER RULES
           -----------------
           Each rule contains filters that should be automatically applied.

           FORMAT:
           'rule_name': {
               filter_name: 'value',
               another_filter_name: 'value1|value2'
           }

           IMPORTANT:
           - Rule names must match pageRuleMapping
           - Use | to allow multiple values for the same filter
           - Filter names and values must be entered in the encoded format due to technical reasons. You can see the filter name format by applying a filter on the storefront and examining the browser address bar
            e.g., if you apply the Modell filter, and look at the address bar, you will see that "rb_filter_metafield_3f0b03c8f85314eb30d1544ffab0be93=some value" is added.
             "filter_metafield_3f0b03c8f85314eb30d1544ffab0be93" is the encoded name that you would need to add in the rule ("rb_" is not needed)

            // brand = Modell = filter_metafield_e5aba23aef69f379aa33e8d68657811a
            // model = Hersteller = filter_metafield_3f0b03c8f85314eb30d1544ffab0be93

        */

        let autoFilterRules = {

            /* ===== EXAMPLE RULE =====
            'new_rule_name': {
                filter_name_here: 'filter value',
                another_filter_name: 'value 1|value 2|value 3', - multiple values are separated by |
            },
               ===== END EXAMPLE ===== */

            'apple_iphone': {
                filter_metafield_e5aba23aef69f379aa33e8d68657811a: 'Apple',
                filter_metafield_3f0b03c8f85314eb30d1544ffab0be93: 'iPhone 16',
            },

            'multi_value_example': {
                some_other_filter: 'some other value|second value for the same filter|third value for the same filter',
            },
        };

        /* 
           PAGE → RULE MAPPING
           -------------------
           Connects pages (collection handles) to a filter rule.

           FORMAT:
           'rule_name': [
               'page-handle-1',
               'page-handle-2'
           ]

           NOTES:
           - Rule name must exist in autoFilterRules
           - Each page handle should appear only once
           - Page handles are Shopify collection page handles or the search results page handle (it is always 'search-results-page')
        */
        let pageRuleMapping = {

            /* ===== EXAMPLE MAPPING =====
            'new_rule_name': [
                'collection-handle-1',
                'collection-handle-2',
                'search-results-page',
            ],
               ===== END EXAMPLE ===== */

            'apple_iphone': [
                'handyhullen',
            ],

            'multi_value_example': [
                'other-collection',
            ],
        };

        /* SETTINGS END */

        /* functional part start (actual code) */

        let initialResultsRequestHandled = false;
        let manufacturerSyncInitialized = false;
        let previousManufacturer = '';
        let currentManufacturer = '';
        let activePageHandle = false;
        let activeRuleFilters = false;
        let filterSessionKeyPrefix = 'snizeCustomAutoFiltersChanged:';
        let manufacturerFilter = 'filter_metafield_e5aba23aef69f379aa33e8d68657811a';
        let modelFilter = 'filter_metafield_3f0b03c8f85314eb30d1544ffab0be93';
        let savedHistoryState = window.history.state || {};
        let restoreTargetPage = Number(savedHistoryState.snizeCustomLoadedPage) || 1;
        let restoreScrollTop = Number(savedHistoryState.snizeCustomScrollTop) || 0;
        let restoreInProgress = restoreTargetPage > 1 || restoreScrollTop > 0;
        let restoreRequestedPage = 0;
        let scrollTimeout;

        let getLoadedPage = function () {
            let previousData = Searchanise.GetWidgets().searchResults.getPrevData();
            let loadedPage = previousData && previousData.params ? Number(previousData.params.page) || 1 : 1;
            let nextPage = Number($('.snize-infinite-loader, a.snize-pagination-load-more').attr('rev'));

            return nextPage ? Math.max(loadedPage, nextPage - 1) : loadedPage;
        };

        let saveHistoryState = function (loadedPage, scrollPosition) {
            let currentHistoryState = window.history.state || {};

            currentHistoryState.snizeCustomLoadedPage = loadedPage;
            if (scrollPosition !== undefined) {
                currentHistoryState.snizeCustomScrollTop = scrollPosition;
            }
            window.history.replaceState(currentHistoryState, '');
        };

        let restoreResults = function () {
            if (!restoreInProgress) {
                return;
            }

            let loadedPage = getLoadedPage();
            if (restoreRequestedPage && loadedPage < restoreRequestedPage) {
                return;
            }
            restoreRequestedPage = 0;

            if (loadedPage < restoreTargetPage) {
                let previousData = Searchanise.GetWidgets().searchResults.getPrevData();
                if (!previousData || !previousData.params) {
                    restoreInProgress = false;
                    return;
                }

                let searchParams = Object.assign({}, previousData.params);
                restoreRequestedPage = loadedPage + 1;
                searchParams.page = restoreRequestedPage;
                searchParams.action = 'moreResults';
                Searchanise.GetWidgets().searchResults.search(searchParams);
                return;
            }

            restoreInProgress = false;
            $(window).scrollTop(restoreScrollTop);
            saveHistoryState(loadedPage, restoreScrollTop);
        };

        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }

        $(document).on('click', '.snize-product-filters-checkbox, .snize-product-filters-reset, .snize-selected-filters .snize-filter-button, .snize-custom-filters-for-mobiles li', function (event) {
            if (event.originalEvent && activePageHandle && activeRuleFilters) {
                window.sessionStorage.setItem(filterSessionKeyPrefix + activePageHandle, '1');
            }
        });

        $(document).on('Searchanise.DataRequestBefore', function (event, type, params) {
            if (type !== 'results' || !params) { return; }

            if (!initialResultsRequestHandled) {
                initialResultsRequestHandled = true;
                params.restrictBy = params.restrictBy || {};
                activePageHandle = params.collection ? params.collection : 'search-results-page';

                let activeRuleEntry = Object.entries(pageRuleMapping).filter(function (mappingEntry) {
                    return mappingEntry[1].includes(activePageHandle);
                })[0];
                let activeRuleName = activeRuleEntry ? activeRuleEntry[0] : false;
                activeRuleFilters = autoFilterRules[activeRuleName] || false;

                let hasExplicitRuleFilter = activeRuleFilters && Object.keys(activeRuleFilters).some(function (filterName) {
                    return Object.prototype.hasOwnProperty.call(params.restrictBy, filterName);
                });

                if (activeRuleFilters && !hasExplicitRuleFilter && window.sessionStorage.getItem(filterSessionKeyPrefix + activePageHandle) !== '1') {
                    Object.entries(activeRuleFilters).forEach(function ([filterName, filterValue]) {
                        params.restrictBy[filterName] = filterValue;
                    });
                }
            }

            currentManufacturer = params.restrictBy ? params.restrictBy[manufacturerFilter] || '' : '';
            if (manufacturerSyncInitialized && previousManufacturer !== currentManufacturer) {
                if (params.restrictBy) {
                    delete params.restrictBy[modelFilter];
                }
                previousManufacturer = currentManufacturer;
            } else if (!manufacturerSyncInitialized) {
                manufacturerSyncInitialized = true;
                previousManufacturer = currentManufacturer;
            }
        });

        $(document).on('Searchanise.ResultsUpdated', function () {
            saveHistoryState(getLoadedPage());
            restoreResults();
        });

        $(window).on('scroll', function () {
            if (restoreInProgress) { return; }

            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(function () {
                saveHistoryState(getLoadedPage(), $(window).scrollTop());
            }, 200);
        });

        $(window).on('pagehide', function () {
            if (!restoreInProgress) {
                saveHistoryState(getLoadedPage(), $(window).scrollTop());
            }
        });

        $(window).on('pageshow', function (event) {
            if (!event.originalEvent || !event.originalEvent.persisted) {
                return;
            }

            let currentHistoryState = window.history.state || {};
            restoreTargetPage = Number(currentHistoryState.snizeCustomLoadedPage) || 1;
            restoreScrollTop = Number(currentHistoryState.snizeCustomScrollTop) || 0;
            restoreInProgress = restoreTargetPage > 1 || restoreScrollTop > 0;
            restoreRequestedPage = 0;
            restoreResults();
        });
    })(window.Searchanise.$);
});